import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useEditRecurringException = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Something went wrong");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({
      staffMemberId,
      type,
      startTime,
      endTime,
      startAt,
      endAt,
      reason,
      allDay,
      exceptionId,
      recurrenceType,
      daysOfWeek,
      interval,
    }) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.put(
        `${tenantVal}/schedule-exceptions/recurring/${exceptionId}`,
        {
          staffMemberId: staffMemberId,
          type: type,
          startTime: startTime,
          endTime: endTime,
          startAt: startAt,
          endAt: endAt,
          isAllDay: allDay,
          reason: reason,
          allDay: allDay,
          recurrenceType: recurrenceType,
          daysOfWeek: daysOfWeek,
          interval: interval,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Recurring exception updated successfully!");
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      onSuccess?.();
    },
    meta: { skipGlobalError: true },
    onError: handleNetworkError,
  });
};
